(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jjs-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jjs-load-more')) customElements.define('jjs-load-more', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click',async event => {
        const link=event.target.closest('a'); if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault(); if(this.busy) return; this.busy=true;
        const label=link.textContent, status=this.querySelector('[role="status"]'); link.setAttribute('aria-disabled','true'); status.textContent=this.dataset.loading;
        try {
          const response=await fetch(link.href,{credentials:'same-origin'}); if(!response.ok)throw new Error();
          const html=new DOMParser().parseFromString(await response.text(),'text/html');
          const scope=this.closest('#ProductGridContainer'),grid=scope.querySelector('#product-grid'),next=html.querySelector('#product-grid');
          if(!grid || !next)throw new Error();
          const first=next.firstElementChild; grid.append(...Array.from(next.children));
          const nextLink=html.querySelector('jjs-load-more a'); if(nextLink)link.href=nextLink.href;else link.remove();
          const pagination=scope.querySelector('.pagination-wrapper'),newPagination=html.querySelector('#ProductGridContainer .pagination-wrapper');
          if(pagination) { if(newPagination)pagination.replaceWith(newPagination);else pagination.remove(); }
          status.textContent=this.dataset.loaded;
          const focusTarget=first?.querySelector('a'); focusTarget?.focus({preventScroll:true});
        } catch { status.textContent=this.dataset.error; link.textContent=label; }
        finally { this.busy=false; link.removeAttribute('aria-disabled'); }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jjs-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jjs-mobile-purchase')) customElements.define('jjs-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.nativeButton = this.form?.querySelector('[name="add"]');
      if (!this.root || !this.nativeButton || !window.IntersectionObserver) return;
      this.button = this.querySelector('[data-sticky-submit]');
      this.update = () => {
        const price = this.root.querySelector('.price .price-item--sale') || this.root.querySelector('.price .price__regular .price-item');
        this.querySelector('[data-sticky-price]').textContent = price?.textContent.trim() || '';
        const picker = this.root.querySelector('variant-radios, variant-selects');
        const options = picker ? Array.from(picker.querySelectorAll('select, input[type="radio"]:checked')).map(el => el.tagName === 'SELECT' ? el.selectedOptions[0]?.textContent.trim() : el.value).filter(Boolean) : [];
        this.querySelector('[data-sticky-options]').textContent = options.join(' / ');
        this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
        this.button.textContent = this.nativeButton.querySelector('span')?.textContent.trim() || this.nativeButton.textContent.trim();
      };
      this.button.addEventListener('click', () => {
        const invalid = Array.from(this.form.elements).find(el => el.willValidate && !el.validity.valid);
        if (invalid) { invalid.scrollIntoView({block:'center'}); invalid.reportValidity(); return; }
        this.nativeButton.click();
        const error = this.root.querySelector('.product-form__error-message-wrapper');
        if (error && !error.hidden) error.scrollIntoView({block:'center'});
      });
      this.querySelector('.jjs-sticky-options').addEventListener('click', () => { this.form.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); this.root.querySelector('variant-radios select, variant-selects select, input[type="radio"], [name="add"]')?.focus({preventScroll:true}); });
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.root.querySelector('product-info'),{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','value']});
      this.root.addEventListener('change',this.update);
      this.intersection = new IntersectionObserver(entries => { const e=entries[0]; this.pastForm=!e.isIntersecting && e.boundingClientRect.bottom<0; this.hidden=!this.pastForm || this.footerVisible; });
      this.intersection.observe(this.form);
      const footer = document.querySelector('.footer');
      if (footer) { this.footerObserver = new IntersectionObserver(entries => { this.footerVisible=entries[0].isIntersecting; this.hidden=!this.pastForm || this.footerVisible; }); this.footerObserver.observe(footer); }
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.intersection?.disconnect(); this.footerObserver?.disconnect(); this.root?.removeEventListener('change',this.update); }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jjs-shipping-estimator"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('jjs-shipping-estimator')) customElements.define('jjs-shipping-estimator',class extends HTMLElement {
    connectedCallback(){
      this.controller=new AbortController();
      this.querySelector('button').addEventListener('click',()=>this.calculate(),{signal:this.controller.signal});
      this.addEventListener('input',()=>this.invalidate(),{signal:this.controller.signal});
      if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>this.invalidate());
    }
    disconnectedCallback(){this.controller?.abort();this.unsubscribe?.();clearTimeout(this.timer);}
    invalidate(){this.sequence=(this.sequence||0)+1; if(this.hasResult){this.querySelector('[data-rates]').textContent=this.dataset.changed;this.hasResult=false;}}
    async calculate(){
      if(this.busy)return;
      const zip=this.querySelector('[name="estimate_zip"]'),country=this.querySelector('[name="estimate_country"]'),province=this.querySelector('[name="estimate_province"]'),status=this.querySelector('[data-rates]'),button=this.querySelector('button');
      if(!zip.value.trim()){zip.focus();return;}
      this.busy=true;button.disabled=true;status.textContent=this.dataset.loading;
      const sequence=this.sequence=(this.sequence||0)+1;
      const params=new URLSearchParams({'shipping_address[zip]':zip.value.trim(),'shipping_address[country]':country.value,'shipping_address[province]':province.value.trim()});
      const options={credentials:'same-origin',signal:this.controller.signal};
      try{
        const prepare=await fetch(`${this.dataset.root}cart/prepare_shipping_rates.json?${params}`,{...options,method:'POST'});
        if(!prepare.ok)throw new Error();
        let result=null;
        for(let attempt=0;attempt<10;attempt++){
          const response=await fetch(`${this.dataset.root}cart/async_shipping_rates.json?${params}`,options);
          if(!response.ok)throw new Error();result=await response.json();
          if(result!==null)break;
          await new Promise(resolve=>{this.timer=setTimeout(resolve,1000);});
        }
        if(sequence!==this.sequence){status.textContent=this.dataset.changed;return;}
        if(!result)throw new Error();
        status.replaceChildren();
        if(!result.shipping_rates?.length){status.textContent=this.dataset.empty;return;}
        const list=document.createElement('ul');
        for(const rate of result.shipping_rates){const item=document.createElement('li');item.textContent=`${rate.presentment_name||rate.name}: ${new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:rate.currency||this.dataset.currency}).format(Number(rate.price))}`;list.append(item);}
        status.append(list);this.hasResult=true;
      }catch(error){if(error.name!=='AbortError')status.textContent=this.dataset.error;}
      finally{this.busy=false;button.disabled=false;}
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jjs-store-utilities"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.jjs-back-to-top').forEach(button => {
    let queued=false;
    const update=()=>{button.hidden=window.scrollY<600;queued=false;};
    window.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(update);}},{passive:true});
    button.addEventListener('click',()=>{window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); const header=document.querySelector('header'); if(header){header.setAttribute('tabindex','-1');header.focus({preventScroll:true});}});update();
  });
  } catch(e) { console.error(e); }
})();

})();
